var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 108,
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2653)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.00391,
    y: 0.834961,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.67057,
    y: 1.50163,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#D9D9D9",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5551 51.3881V47.4992C91.5551 26.0209 74.1446 8.61035 52.6662 8.61035C31.1879 8.61035 13.7773 26.0209 13.7773 47.4992C13.7773 56.2531 16.6707 64.3342 21.5551 70.8326",
    stroke: "black",
    strokeWidth: 3.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5543 8.80176C56.5543 8.80176 68.221 24.1629 68.221 47.4962V51.3851M48.7766 8.80176C48.7766 8.80176 37.1099 24.1629 37.1099 47.4962V51.3851M16.2266 61.1112H21.5543M16.2266 33.889H89.1043M56.5543 86.389V63.0557L68.221 86.389V63.0557M79.8877 86.389H87.6654C89.2125 86.389 90.6963 85.7744 91.7902 84.6804C92.8842 83.5865 93.4988 82.1027 93.4988 80.5557C93.4988 79.0086 92.8842 77.5248 91.7902 76.4309C90.6963 75.3369 89.2125 74.7223 87.6654 74.7223H85.721C84.1739 74.7223 82.6902 74.1077 81.5962 73.0138C80.5023 71.9198 79.8877 70.4361 79.8877 68.889C79.8877 67.3419 80.5023 65.8582 81.5962 64.7642C82.6902 63.6702 84.1739 63.0557 85.721 63.0557H91.5543M33.221 86.389V63.0557H37.1099C39.1727 63.0557 41.151 63.8751 42.6096 65.3337C44.0682 66.7923 44.8877 68.7706 44.8877 70.8334V78.6112C44.8877 80.674 44.0682 82.6523 42.6096 84.1109C41.151 85.5695 39.1727 86.389 37.1099 86.389H33.221Z",
    stroke: "black",
    strokeWidth: 3.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2653",
    x: 0.670573,
    y: 0.834961,
    width: 103.999,
    height: 106.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2653"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2653",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC5);
export default __webpack_public_path__ + "static/media/c5.64bc0b4cdb3d3ead530c54c72ed3994f.svg";
export { ForwardRef as ReactComponent };